import { create } from 'zustand';

/**
 * O índice de metais abre por cima de qualquer tela: no meio de um fechamento o
 * comprador consulta o cobre e volta ao mesmo lugar, com o que já marcou e
 * digitou. Um modal só, montado no AppShell; menu e telas só pedem para abrir.
 */
type IndicesModalState = {
  aberto: boolean;
  abrir: () => void;
  fechar: () => void;
};

export const useIndicesModal = create<IndicesModalState>((set) => ({
  aberto: false,
  abrir: () => set({ aberto: true }),
  fechar: () => set({ aberto: false }),
}));
